<!-- 测试方式 -->
<template>
  <BaseFormItem2
    class="test"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isShowNewIcon="isShowNewIcon"
  >
    <div :class="{ 'is-loading': loading }">
      <BaseRadioGroup2 v-model="val" @change="handleEmit">
        <el-radio-button
          v-for="item in options"
          :key="item.value"
          :label="item.value"
          :disabled="item.disabled"
          @click.native.prevent="handleRadioClick(item.value)"
        >{{ item.label }}</el-radio-button>
      </BaseRadioGroup2>
      <i v-if="loading" class="el-icon-loading test__loading"></i>
    </div>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: '样品免费测试'
    },
    // 测试方式展示(前端字段)
    view_test: {
      type: String,
      default: ''
    },
    testOptions: {
      type: Array,
      default: () => ([])
    },
    // 计价loading
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('test')
    },
    options() {
      const { fields, testOptions } = this
      if (testOptions && testOptions.length > 0) {
        return testOptions.map(({ real, word }) => ({ label: word, value: real }))
      }
      
      return fields.options
    },
    // 是否显示 NEW 标识
    isShowNewIcon() {
      return new Date().getTime() <= new Date('2026-08-13').getTime()
    }
  },
  watch: {
    value(newVal) {
      if (this.val != newVal && newVal == '批量测试架测试') {
        this.showTipDialog({ showCancelButton: false }).catch(() => {})
      }
      if (this.val != newVal && this.val == '抽测') { 
        this.changeVal(newVal)
      }
      this.val = newVal
      this.handleEmit()
    },
    testOptions(testOptions) {
      this.testOptions = testOptions
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)

      const item = this.options.find(item => item.value == val)
      if (item) {
        this.$emit('update:view_test', item.label)
      }
    },
    changeVal(val) {
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    },
    showTipDialog(options = {}) {
      return new Promise((resolve) => {
        const msg = `
          <div>
            <p>新开测试架从下单(含返单)之日起，会帮客户保管1年，不支持客户提走。</p> 
            <p>如连续12个月内有返单，返单不收取测试费；连续12个月无返单，我司自行处理，请再次确认是否选AOI+测试架。</p>  
          </div>
        `
        this.$confirm(msg, '温馨提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          lockScroll: false,
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          closeOnPressEscape: true,
          customClass: 'test__dialog',
          ...options
        })
        .then(() => resolve(true))
        .catch(() => resolve(false))
      })
    },
    handleRadioClick(value) {
      // 当切换到 AOI+测试架 时，显示二次确认提示弹框
      if (value == '批量测试架测试' && this.val != '批量测试架测试') {
        this.showTipDialog()
          .then((isConfirm) => {
            if (isConfirm) {
              this.val = value
              this.handleEmit()
            }
          })
          .catch(() => {})
      } else {
        this.val = value
        this.handleEmit()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.test {
  .is-loading {
    position: relative;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 99;
      background: rgba(255, 255, 255, 0.45);
    }
    .test__loading {
      margin-left: 10px;
      font-size: 16px;
    }
  }
}
</style>
<style lang="scss">
.test__dialog.el-message-box {
  width: 540px;
}
</style>